import teacherReducer from './';

export default teacherReducer;
